import React from "react";
import { SealCheck } from "@phosphor-icons/react";

/**
 * VerifiedTierChip — visual indicator of a candidate's identity verification.
 *
 *  tier "paid"  → Blue "Verified" (₹299 paid badge + admin approval)
 *  tier "kyc"   → Emerald "KYC-verified" (AI-verified Aadhaar / PAN, free)
 *  tier null    → renders nothing
 *
 * V1.5.8.15 — introduced so recruiter cards on `/candidates`, `/requirements/:id`
 * and the marketplace show the SAME tier semantics.
 */
export default function VerifiedTierChip({ tier, size = "sm", className = "" }) {
    if (!tier) return null;
    const isPaid = tier === "paid";
    const label = isPaid ? "Verified" : "KYC-verified";
    const title = isPaid
        ? "Paid Verified Badge (₹299) — ID docs approved by admin"
        : "KYC-verified (AI-verified Aadhaar / PAN). No paid badge.";
    const tone = isPaid
        ? "bg-cobalt text-white"
        : "bg-emerald-600 text-white";
    const sizes = size === "xs"
        ? "text-[9px] px-1.5 py-0.5"
        : "text-[10px] px-2 py-0.5";
    return (
        <span
            title={title}
            data-testid={`verified-tier-${tier}`}
            className={`inline-flex items-center gap-1 font-black uppercase tracking-wider ${sizes} ${tone} ${className}`}
        >
            <SealCheck size={size === "xs" ? 10 : 11} weight="fill" /> {label}
        </span>
    );
}
